import { render, staticRenderFns } from "./ModelSearch.vue?vue&type=template&id=08ae78e6&scoped=true&"
import script from "./ModelSearch.vue?vue&type=script&lang=js&"
export * from "./ModelSearch.vue?vue&type=script&lang=js&"
import style0 from "./ModelSearch.vue?vue&type=style&index=0&id=08ae78e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae78e6",
  null
  
)

export default component.exports